import { styled } from "../../../styled-system/jsx";

const Card = styled("button", {
  base: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "small",
    marginBottom: "16px",
    border: "1px solid #e5e7eb",
    color: "black",
    fontSize: "14px",
    width: "100%",
    textAlign: "left",
  },
  variants: {
    active: {
      true: {
        borderColor: "fuchsia",
      },
      false: {
        borderColor: "#e5e7eb",
      },
    },
    hoverable: {
      true: {
        _hover: {
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        },
        transition: "box-shadow 0.2s ease-in-out",
      },
      false: {},
    },
  },
});

export default Card;
